import { getWrestlerName, getWrestlerNameUpper, wrestlerMatchesSearch, sortWrestlersByName } from './wrestlerUtils';
import CustomWrestlerEditor from './CustomWrestlerEditor';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from '../firebase';
import React, { useState, useEffect, useMemo } from 'react';
import { collection, addDoc, getDocs, deleteDoc, doc, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import background from '../assets/Background_Test.jpg';
import placeholder from '../assets/placeholder.png';

import logoRaw from '../assets/brands/logos/RAW25_LOGO.png';
import logoSmackDown from '../assets/brands/logos/SMACKDOWN25_LOGO.png';
import logoNXT from '../assets/brands/logos/NXT_LOGO.png';
import logoNXT20 from '../assets/brands/logos/NXT20_LOGO.png';
import logoWCW from '../assets/brands/logos/WCW_LOGO.png';
import logoECW from '../assets/brands/logos/ECW_LOGO.png';
import logoNXTMutiny from '../assets/brands/logos/NXTMUTINY_LOGO.png';
import bgRaw from '../assets/brands/backgrounds/RAW25_BACKGROUND.png';
import bgSmackDown from '../assets/brands/backgrounds/SMACKDOWN25_BACKGROUND.png';
import bgNXT from '../assets/brands/backgrounds/NXT_BACKGROUND.png';
import bgNXT20 from '../assets/brands/backgrounds/NXT20_BACKGROUND.png';
import bgWCW from '../assets/brands/backgrounds/WCW_BACKGROUND.png';
import bgECW from '../assets/brands/backgrounds/ECW_BACKGROUND.png';
import bgNXTMutiny from '../assets/brands/backgrounds/NXTMUTINY_BACKGROUND.png';


// Dynamic wrestler render loader
const getWrestlerRender = (w) => {
  if (!w) return null;
  if (w.customRender) return w.customRender;
  if (w.wrestler_id) return process.env.PUBLIC_URL + '/wrestlers/' + w.wrestler_id + '-render.png';
  return null;
};

const BRAND_LOGOS = { 'Raw': logoRaw, 'SmackDown': logoSmackDown, 'NXT': logoNXT, 'NXT 2.0': logoNXT20, 'WCW': logoWCW, 'ECW': logoECW, 'NXT Mutiny': logoNXTMutiny };
const BRAND_BGS = { 'Raw': bgRaw, 'SmackDown': bgSmackDown, 'NXT': bgNXT, 'NXT 2.0': bgNXT20, 'WCW': bgWCW, 'ECW': bgECW, 'NXT Mutiny': bgNXTMutiny };
const BRAND_COLORS = { 'Raw': '#c0392b', 'SmackDown': '#1a6bb5', 'NXT': '#a8a9ad', 'NXT 2.0': '#e91e8c', 'ECW': '#7b1fa2', 'WCW': '#e65100', 'NXT Mutiny': '#424242' };
const CLASS_COLORS = { 'Fighter': '#3498db', 'Bruiser': '#e74c3c', 'Cruiser': '#2ecc71', 'Specialist': '#9b59b6', 'Giant': '#e67e22' };
const STATUS_COLORS = { 'active': '#2ecc71', 'contract': '#3498db', 'inactive': '#888', 'local': '#f39c12' };


const css = `
  * { box-sizing: border-box; }
  html { font-size: 133%; }
  .row-hover { transition: background 0.12s; cursor: pointer; }
  .row-hover:hover { background: rgba(255,255,255,0.06) !important; }
  .row-hover.sel-row { background: rgba(255,255,255,0.09) !important; }
  .row-inactive { opacity: 0.45; }
  .btn-wwe:hover { background: rgba(255,255,255,0.1) !important; border-color: rgba(255,255,255,0.7) !important; color: #fff !important; }
  .btn-edit:hover { color: #fff !important; border-color: rgba(255,255,255,0.5) !important; }
  .roster-card:hover { outline: 1.5px solid rgba(255,255,255,0.5) !important; background: rgba(255,255,255,0.06) !important; }
  .roster-card.selected-card { outline: 2px solid rgba(255,255,255,0.75) !important; }
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 2px; }
  select option { background: #1a1a1a; color: #fff; }
  input[type=checkbox] { accent-color: #d4af37; width: 14px; height: 14px; cursor: pointer; }
`;


// ── Firebase Storage upload helper ──────────────────────────────────
async function uploadRenderToStorage(file, userId, entityId, type) {
  // type = 'wrestler' | 'title'
  var path = 'renders/' + userId + '/' + type + '/' + entityId + '_' + Date.now();
  var storageRef = ref(storage, path);
  var snapshot = await uploadBytes(storageRef, file);
  var url = await getDownloadURL(snapshot.ref);
  return { url: url, path: path };
}

async function deleteRenderFromStorage(storagePath) {
  if (!storagePath) return;
  try {
    var storageRef = ref(storage, storagePath);
    await deleteObject(storageRef);
  } catch (e) {
    console.warn('Could not delete old render:', e);
  }
}

const panel = {
  background: 'rgba(8,8,8,0.88)',
  border: '1px solid rgba(255,255,255,0.09)',
  borderRadius: '10px',
  boxShadow: '0 20px 80px rgba(0,0,0,0.9), inset 0 1px 0 rgba(255,255,255,0.04)',
};

const titleSt = { fontFamily: "'Anton', sans-serif", letterSpacing: '3px', color: '#fff', textShadow: '0 0 28px rgba(180,0,0,0.5)' };

const btnSt = {
  fontFamily: "'Monda', sans-serif", letterSpacing: '1.5px', fontSize: '0.62rem',
  background: 'transparent', border: '1px solid rgba(255,255,255,0.35)',
  color: 'rgba(255,255,255,0.8)', padding: '9px 28px', borderRadius: '4px',
  cursor: 'pointer', transition: 'background 0.18s, border-color 0.18s, color 0.18s',
};

const inputSt = {
  background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.15)',
  borderRadius: '4px', padding: '7px 12px', color: '#fff', fontSize: '0.62rem',
  fontFamily: "'Monda', sans-serif", outline: 'none', transition: 'border-color 0.2s', letterSpacing: '0.5px',
};

const labelSt = { color: 'rgba(255,255,255,0.4)', fontSize: '0.55rem', letterSpacing: '1px', fontFamily: "'Monda', sans-serif", marginBottom: '4px', display: 'block' };

const colHeaderSt = {
  fontFamily: "'Monda', sans-serif", fontSize: '0.52rem', letterSpacing: '1.5px',
  color: 'rgba(255,255,255,0.38)', padding: '7px 8px', textAlign: 'left',
  borderBottom: '1px solid rgba(255,255,255,0.07)', whiteSpace: 'nowrap', userSelect: 'none',
};

const PageWrapper = ({ brand, children }) => {
  const brandBg = BRAND_BGS[brand];
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 40 }}>
      <img loading="lazy" src={background} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }} />
      {brandBg && <img loading="lazy" src={brandBg} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.2, zIndex: 1 }} />}
      <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at center, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.85) 100%)', zIndex: 2 }} />
      <div style={{ position: 'absolute', inset: 0, zIndex: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '80px 24px 20px' }}>
        {children}
      </div>
    </div>
  );
};

// ── Edit Superstar Popup ────────────────────────────────────────────
const EditSuperstarsPopup = ({ wrestler, originalWrestler, onClose, onSave, onDelete, user }) => {
  const [form, setForm] = useState({
    name: getWrestlerName(wrestler, 'display'),
    status: wrestler.status || 'active',
    gender: wrestler.gender || 'M',
    fight_class: wrestler.fight_class || 'Fighter',
    heel: wrestler.heel || false,
    starting_xp: wrestler.starting_xp || 0,
    popularity: wrestler.popularity || 0,
    promo_skill: wrestler.promo_skill || 1,
    customRender: wrestler.customRender || null,
  });
  const [confirmReset, setConfirmReset] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const [uploadingRender, setUploadingRender] = useState(false);

  const handleRenderUpload = async (e) => {
    var file = e.target.files[0];
    if (!file) return;
    setUploadingRender(true);
    try {
      var entityId = wrestler && wrestler.wrestler_id ? String(wrestler.wrestler_id) : 'new_' + Date.now();
      var result = await uploadRenderToStorage(file, user && user.uid || 'anonymous', entityId, 'wrestler');
      // Delete old storage render if exists
      if (form.customRenderPath) await deleteRenderFromStorage(form.customRenderPath);
      setForm(function(p) { return { ...p, customRender: result.url, customRenderPath: result.path }; });
    } catch (err) {
      console.error('Upload failed:', err);
      // Fallback to base64 if Storage fails
      var reader = new FileReader();
      reader.onload = function(ev) { setForm(function(p) { return { ...p, customRender: ev.target.result }; }); };
      reader.readAsDataURL(file);
    } finally {
      setUploadingRender(false);
    }
  };

  const handleReset = () => {
    if (!originalWrestler) return;
    setForm({
      name: getWrestlerName(originalWrestler, 'display'),
      status: originalWrestler.status || 'active',
      gender: originalWrestler.gender || 'M',
      fight_class: originalWrestler.fight_class || 'Fighter',
      heel: originalWrestler.heel || false,
      starting_xp: originalWrestler.starting_xp || 0,
      popularity: originalWrestler.popularity || 0,
      promo_skill: originalWrestler.promo_skill || 1,
      customRender: null,
    });
    setConfirmReset(false);
  };

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(4px)' }}>
      <div style={{ ...panel, width: '100%', maxWidth: '520px', padding: '28px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div style={{ ...titleSt, fontSize: '1rem' }}>EDIT SUPERSTAR</div>
          <div style={{ display: 'flex', gap: '8px' }}>
            {originalWrestler && !wrestler.isCustom && (
              <button className="btn-wwe" style={{ ...btnSt, fontSize: '0.48rem', padding: '5px 10px', borderColor: 'rgba(241,196,15,0.5)', color: '#f1c40f' }}
                onClick={() => setConfirmReset(true)}>RESET STATS</button>
            )}
            {wrestler.isCustom && (
              <button className="btn-wwe" style={{ ...btnSt, fontSize: '0.48rem', padding: '5px 10px', borderColor: 'rgba(231,76,60,0.5)', color: '#e74c3c' }}
                onClick={() => setConfirmDelete(true)}>DELETE</button>
            )}
          </div>
        </div>

        <div style={{ display: 'flex', gap: '16px' }}>
          {/* Render upload */}
          <div style={{ width: '130px', flexShrink: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <label style={labelSt}>RENDER</label>
            <div onClick={() => document.getElementById('editRenderUpload').click()}
              style={{ width: '130px', height: '160px', border: '1px dashed rgba(255,255,255,0.2)', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', overflow: 'hidden', background: 'rgba(255,255,255,0.03)', position: 'relative' }}>
              {form.customRender
                ? <img loading="lazy" src={form.customRender} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top' }} />
                : <span style={{ color: 'rgba(255,255,255,0.2)', fontSize: '0.5rem', fontFamily: "'Monda', sans-serif", textAlign: 'center', padding: '8px', lineHeight: 1.5 }}>Upload render PNG 1024×1024</span>}
            </div>
            <input id="editRenderUpload" type="file" accept="image/png" style={{ display: 'none' }} onChange={handleRenderUpload} />
            {form.customRender && (
              <button className="btn-wwe" style={{ ...btnSt, fontSize: '0.44rem', padding: '4px 8px', borderColor: 'rgba(231,76,60,0.4)', color: 'rgba(231,76,60,0.7)', width: '100%' }}
                onClick={() => setForm(p => ({ ...p, customRender: null }))}>
                ✕ Supprimer render
              </button>
            )}
          </div>

          {/* Fields */}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div>
              <label style={labelSt}>NOM</label>
              <input style={inputSt} value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))}
                onFocus={e => e.target.style.borderColor = 'rgba(255,255,255,0.5)'}
                onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.15)'} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              <div>
                <label style={labelSt}>STATUS</label>
                <select style={{ ...inputSt, width: '100%', cursor: 'pointer' }} value={form.status} onChange={e => setForm(p => ({ ...p, status: e.target.value }))}>
                  <option value="active">Active</option>
                  <option value="contract">Contract</option>
                  <option value="local">Local</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
              <div>
                <label style={labelSt}>GENRE</label>
                <select style={{ ...inputSt, width: '100%', cursor: 'pointer' }} value={form.gender} onChange={e => setForm(p => ({ ...p, gender: e.target.value }))}>
                  <option value="M">Male</option>
                  <option value="F">Female</option>
                </select>
              </div>
              <div>
                <label style={labelSt}>CLASS</label>
                <select style={{ ...inputSt, width: '100%', cursor: 'pointer' }} value={form.fight_class} onChange={e => setForm(p => ({ ...p, fight_class: e.target.value }))}>
                  {['Fighter', 'Bruiser', 'Cruiser', 'Specialist', 'Giant'].map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div>
                <label style={labelSt}>ROLE</label>
                <select style={{ ...inputSt, width: '100%', cursor: 'pointer' }} value={form.heel ? 'heel' : 'face'} onChange={e => setForm(p => ({ ...p, heel: e.target.value === 'heel' }))}>
                  <option value="face">Face</option>
                  <option value="heel">Heel</option>
                </select>
              </div>
              <div>
                <label style={labelSt}>RING XP</label>
                <select style={{ ...inputSt, width: '100%', cursor: 'pointer' }} value={form.starting_xp} onChange={e => setForm(p => ({ ...p, starting_xp: Number(e.target.value) }))}>
                  {[0, 5, 10, 15, 20, 25].map(v => <option key={v} value={v}>{v}</option>)}
                </select>
              </div>
              <div>
                <label style={labelSt}>POPULARITÉ</label>
                <input type="number" style={{ ...inputSt, width: '100%' }} value={form.popularity}
                  onChange={e => setForm(p => ({ ...p, popularity: Number(e.target.value) }))}
                  min={0} max={100} />
              </div>
              <div>
                <label style={labelSt}>PROMO SKILL</label>
                <select style={{ ...inputSt, width: '100%', cursor: 'pointer' }} value={form.promo_skill} onChange={e => setForm(p => ({ ...p, promo_skill: Number(e.target.value) }))}>
                  {[1, 2, 3, 4, 5].map(v => <option key={v} value={v}>{v}</option>)}
                </select>
              </div>
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
          <button className="btn-wwe" style={btnSt} onClick={onClose}>CANCEL</button>
          <button className="btn-wwe" style={{ ...btnSt, borderColor: 'rgba(255,255,255,0.55)', color: '#fff' }} onClick={() => onSave(form)}>SAVE</button>
        </div>
      </div>

      {/* Confirm Reset */}
      {confirmReset && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 400, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.8)' }}>
          <div style={{ ...panel, maxWidth: '360px', width: '100%', padding: '24px', textAlign: 'center' }}>
            <div style={{ fontFamily: "'Anton', sans-serif", fontSize: '0.9rem', color: '#f1c40f', letterSpacing: '2px', marginBottom: '10px' }}>RESET STATS?</div>
            <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.55rem', color: 'rgba(255,255,255,0.4)', marginBottom: '20px' }}>
              Les stats de {getWrestlerName(wrestler, 'display')} seront remises aux valeurs d'origine.
            </div>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button className="btn-wwe" style={btnSt} onClick={() => setConfirmReset(false)}>CANCEL</button>
              <button className="btn-wwe" style={{ ...btnSt, borderColor: 'rgba(241,196,15,0.6)', color: '#f1c40f' }} onClick={handleReset}>RESET</button>
            </div>
          </div>
        </div>
      )}

      {/* Confirm Delete */}
      {confirmDelete && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 400, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.8)' }}>
          <div style={{ ...panel, maxWidth: '360px', width: '100%', padding: '24px', textAlign: 'center' }}>
            <div style={{ fontFamily: "'Anton', sans-serif", fontSize: '0.9rem', color: '#e74c3c', letterSpacing: '2px', marginBottom: '10px' }}>DELETE SUPERSTAR?</div>
            <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.55rem', color: 'rgba(255,255,255,0.4)', marginBottom: '20px' }}>
              {getWrestlerName(wrestler, 'display')} sera supprimé définitivement du roster.
            </div>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button className="btn-wwe" style={btnSt} onClick={() => setConfirmDelete(false)}>CANCEL</button>
              <button className="btn-wwe" style={{ ...btnSt, borderColor: 'rgba(231,76,60,0.6)', color: '#e74c3c' }} onClick={() => onDelete(wrestler.wrestler_id)}>DELETE</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ── Add New Superstar Popup ─────────────────────────────────────────
const AddSuperstarsPopup = ({ onClose, onAdd, user }) => {
  const [form, setForm] = useState({ nick_name: '', first_name: '', middle_name: '', last_name: '', status: 'active', gender: 'M', fight_class: 'Fighter', heel: false, starting_xp: 0, popularity: 50, promo_skill: 1, customRender: null });

  const [uploadingRender, setUploadingRender] = useState(false);

  const handleRenderUpload = async (e) => {
    var file = e.target.files[0];
    if (!file) return;
    setUploadingRender(true);
    try {
      var entityId = 'new_' + Date.now();
      var result = await uploadRenderToStorage(file, user && user.uid || 'anonymous', entityId, 'wrestler');
      setForm(function(p) { return { ...p, customRender: result.url, customRenderPath: result.path }; });
    } catch (err) {
      console.error('Upload failed:', err);
      var reader = new FileReader();
      reader.onload = function(ev) { setForm(function(p) { return { ...p, customRender: ev.target.result }; }); };
      reader.readAsDataURL(file);
    } finally {
      setUploadingRender(false);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(4px)' }}>
      <div style={{ ...panel, width: '100%', maxWidth: '520px', padding: '28px' }}>
        <div style={{ ...titleSt, fontSize: '1rem', marginBottom: '20px' }}>NEW SUPERSTAR</div>
        <div style={{ display: 'flex', gap: '16px' }}>
          {/* Render upload */}
          <div style={{ width: '130px', flexShrink: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <label style={labelSt}>RENDER</label>
            <div onClick={() => document.getElementById('addRenderUpload').click()}
              style={{ width: '130px', height: '160px', border: '1px dashed rgba(255,255,255,0.2)', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', overflow: 'hidden', background: 'rgba(255,255,255,0.03)' }}>
              {form.customRender
                ? <img loading="lazy" src={form.customRender} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top' }} />
                : <span style={{ color: 'rgba(255,255,255,0.2)', fontSize: '0.5rem', fontFamily: "'Monda', sans-serif", textAlign: 'center', padding: '8px', lineHeight: 1.5 }}>Upload render PNG 1024×1024</span>}
            </div>
            <input id="addRenderUpload" type="file" accept="image/png" style={{ display: 'none' }} onChange={handleRenderUpload} />
            {form.customRender && (
              <button className="btn-wwe" style={{ ...btnSt, fontSize: '0.44rem', padding: '4px 8px', borderColor: 'rgba(231,76,60,0.4)', color: 'rgba(231,76,60,0.7)', width: '100%' }}
                onClick={() => setForm(p => ({ ...p, customRender: null }))}>✕ Supprimer</button>
            )}
          </div>
          {/* Fields */}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <div>
                <label style={labelSt}>NICK NAME</label>
                <input style={inputSt} value={form.nick_name} onChange={e => setForm(p => ({ ...p, nick_name: e.target.value }))}
                  onFocus={e => e.target.style.borderColor = 'rgba(255,255,255,0.5)'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.15)'}
                  placeholder="ex: Stone Cold" />
              </div>
              <div>
                <label style={labelSt}>FIRST NAME *</label>
                <input style={inputSt} value={form.first_name} onChange={e => setForm(p => ({ ...p, first_name: e.target.value }))}
                  onFocus={e => e.target.style.borderColor = 'rgba(255,255,255,0.5)'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.15)'}
                  placeholder="ex: Steve" />
              </div>
              <div>
                <label style={labelSt}>MIDDLE NAME</label>
                <input style={inputSt} value={form.middle_name} onChange={e => setForm(p => ({ ...p, middle_name: e.target.value }))}
                  onFocus={e => e.target.style.borderColor = 'rgba(255,255,255,0.5)'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.15)'}
                  placeholder="ex: The Hitman" />
              </div>
              <div>
                <label style={labelSt}>LAST NAME</label>
                <input style={inputSt} value={form.last_name} onChange={e => setForm(p => ({ ...p, last_name: e.target.value }))}
                  onFocus={e => e.target.style.borderColor = 'rgba(255,255,255,0.5)'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.15)'}
                  placeholder="ex: Austin" />
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              <div>
                <label style={labelSt}>STATUS</label>
                <select style={{ ...inputSt, width: '100%', cursor: 'pointer' }} value={form.status} onChange={e => setForm(p => ({ ...p, status: e.target.value }))}>
                  <option value="active">Active</option>
                  <option value="contract">Contract</option>
                  <option value="local">Local</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
              <div>
                <label style={labelSt}>GENRE</label>
                <select style={{ ...inputSt, width: '100%', cursor: 'pointer' }} value={form.gender} onChange={e => setForm(p => ({ ...p, gender: e.target.value }))}>
                  <option value="M">Male</option>
                  <option value="F">Female</option>
                </select>
              </div>
              <div>
                <label style={labelSt}>CLASS</label>
                <select style={{ ...inputSt, width: '100%', cursor: 'pointer' }} value={form.fight_class} onChange={e => setForm(p => ({ ...p, fight_class: e.target.value }))}>
                  {['Fighter', 'Bruiser', 'Cruiser', 'Specialist', 'Giant'].map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div>
                <label style={labelSt}>ROLE</label>
                <select style={{ ...inputSt, width: '100%', cursor: 'pointer' }} value={form.heel ? 'heel' : 'face'} onChange={e => setForm(p => ({ ...p, heel: e.target.value === 'heel' }))}>
                  <option value="face">Face</option>
                  <option value="heel">Heel</option>
                </select>
              </div>
              <div>
                <label style={labelSt}>RING XP</label>
                <select style={{ ...inputSt, width: '100%', cursor: 'pointer' }} value={form.starting_xp} onChange={e => setForm(p => ({ ...p, starting_xp: Number(e.target.value) }))}>
                  {[0, 5, 10, 15, 20, 25].map(v => <option key={v} value={v}>{v}</option>)}
                </select>
              </div>
              <div>
                <label style={labelSt}>POPULARITÉ</label>
                <input type="number" style={{ ...inputSt, width: '100%' }} value={form.popularity}
                  onChange={e => setForm(p => ({ ...p, popularity: Number(e.target.value) }))}
                  min={0} max={100} />
              </div>
              <div>
                <label style={labelSt}>PROMO SKILL</label>
                <select style={{ ...inputSt, width: '100%', cursor: 'pointer' }} value={form.promo_skill} onChange={e => setForm(p => ({ ...p, promo_skill: Number(e.target.value) }))}>
                  {[1, 2, 3, 4, 5].map(v => <option key={v} value={v}>{v}</option>)}
                </select>
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
          <button className="btn-wwe" style={btnSt} onClick={onClose}>CANCEL</button>
          <button className="btn-wwe" style={{ ...btnSt, borderColor: form.first_name ? 'rgba(255,255,255,0.55)' : 'rgba(255,255,255,0.2)', color: form.first_name ? '#fff' : 'rgba(255,255,255,0.3)' }}
            onClick={() => form.first_name && onAdd({ ...form, name: [form.nick_name, form.first_name, form.middle_name, form.last_name].filter(Boolean).join(' '), wrestler_id: `custom_${Date.now()}`, isCustom: true })}>
            ADD
          </button>
        </div>
      </div>
    </div>
  );
};

// ── STEP 1: Choose NEW or LOAD ──────────────────────────────────────
const StepChoice = ({ brand, onNew, onLoad, onClose }) => {
  const brandLogo = BRAND_LOGOS[brand];
  return (
    <PageWrapper brand={brand}>
      <style>{css}</style>
      <div style={{ width: '100%', maxWidth: '500px', display: 'flex', flexDirection: 'column', gap: '24px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          {brandLogo && <img loading="lazy" src={brandLogo} alt={brand} style={{ height: '40px', objectFit: 'contain', filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.9))' }} />}
          <div style={{ ...titleSt, fontSize: '1.4rem' }}>CUSTOM ROSTER</div>
        </div>
        <div style={{ ...panel, padding: '28px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.58rem', color: 'rgba(255,255,255,0.35)', letterSpacing: '1px', marginBottom: '4px' }}>CHOISISSEZ UNE OPTION</div>
          <button className="btn-wwe" onClick={onNew}
            style={{ ...btnSt, width: '100%', padding: '18px', fontSize: '0.72rem', letterSpacing: '3px', borderColor: 'rgba(255,255,255,0.4)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }}>
            <span style={{ fontSize: '1.1rem' }}>+</span>
            NEW ROSTER
            <span style={{ fontSize: '0.46rem', color: 'rgba(255,255,255,0.3)', letterSpacing: '1px' }}>Créer un nouveau roster personnalisé</span>
          </button>
          <button className="btn-wwe" onClick={onLoad}
            style={{ ...btnSt, width: '100%', padding: '18px', fontSize: '0.72rem', letterSpacing: '3px', borderColor: 'rgba(255,255,255,0.4)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }}>
            <span style={{ fontSize: '1.1rem' }}>↓</span>
            LOAD ROSTER
            <span style={{ fontSize: '0.46rem', color: 'rgba(255,255,255,0.3)', letterSpacing: '1px' }}>Charger un roster déjà sauvegardé</span>
          </button>
        </div>
        <button className="btn-wwe" style={{ ...btnSt, alignSelf: 'flex-start', color: 'rgba(255,255,255,0.35)', borderColor: 'rgba(255,255,255,0.15)' }} onClick={onClose}>← BACK</button>
      </div>
    </PageWrapper>
  );
};

// ── STEP 2a: NEW roster editor ──────────────────────────────────────
const StepNewRoster = ({ brand, wrestlers, user, onBack, onSaveAndConfirm, initialRoster, initialName }) => {
  const [rosterName, setRosterName] = useState(initialName || '');
  const [search, setSearch] = useState('');
  const [sortKey, setSortKey] = useState('name');
  const [sortDir, setSortDir] = useState('asc');
  const [roster, setRoster] = useState(() => {
    if (initialRoster && initialRoster.length > 0) {
      const initialIds = new Set(initialRoster.map(w => w.wrestler_id));
      // Merge: wrestlers from DB with custom ones from initialRoster
      const customOnes = initialRoster.filter(w => w.isCustom);
      return [...wrestlers.map(w => ({ ...w, status: initialIds.has(w.wrestler_id) ? w.status : w.status })), ...customOnes];
    }
    return wrestlers.map(w => ({ ...w }));
  });
  const [hoveredIdx, setHoveredIdx] = useState(null);
  const [selectedIdx, setSelectedIdx] = useState(null);
  const [editTarget, setEditTarget] = useState(null);
  const [showCustomEditor, setShowCustomEditor] = useState(false);
  const [saving, setSaving] = useState(false);

  const brandColor = BRAND_COLORS[brand] || '#d4af37';
  const brandLogo = BRAND_LOGOS[brand];

  const filtered = useMemo(() => {
    let list = roster.filter(w => wrestlerMatchesSearch(w, search));
    if (sortKey === 'custom') {
      list = list.filter(w => w.isCustom);
    } else {
      list = [...list].sort((a, b) => {
        let va, vb;
        if (sortKey === 'name') { va = getWrestlerName(a, 'display'); vb = getWrestlerName(b, 'display'); }
        else if (sortKey === 'status') { va = a.status || ''; vb = b.status || ''; }
        else if (sortKey === 'gender') { va = a.gender || ''; vb = b.gender || ''; }
        else if (sortKey === 'class') { va = a.fight_class || ''; vb = b.fight_class || ''; }
        else if (sortKey === 'role') { va = a.heel ? 'heel' : 'face'; vb = b.heel ? 'heel' : 'face'; }
        else if (sortKey === 'xp') { return sortDir === 'asc' ? (a.starting_xp || 0) - (b.starting_xp || 0) : (b.starting_xp || 0) - (a.starting_xp || 0); }
        else if (sortKey === 'promo') { return sortDir === 'asc' ? (a.promo_skill || 0) - (b.promo_skill || 0) : (b.promo_skill || 0) - (a.promo_skill || 0); }
        if (typeof va === 'string') return sortDir === 'asc' ? va.localeCompare(vb) : vb.localeCompare(va);
        return 0;
      });
    }
    return list;
  }, [roster, search, sortKey, sortDir]);

  const activeW = hoveredIdx !== null ? filtered[hoveredIdx] : (selectedIdx !== null ? filtered[selectedIdx] : null);
  const includedCount = roster.filter(w => w.status === 'active').length;



  const handleEdit = (w) => setEditTarget(w);
  const originalWrestlers = wrestlers;

  const handleSaveEdit = (updated) => {
    setRoster(prev => prev.map(w => w.wrestler_id === editTarget.wrestler_id ? { ...w, ...updated } : w));
    setEditTarget(null);
  };

  const handleAddSuperstar = (newW) => {
    setRoster(prev => [...prev, { ...newW, included: true }]);
  };

  const handleSortClick = (key) => {
    if (sortKey === key) setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    else { setSortKey(key); setSortDir('asc'); }
  };

  const SortTh = ({ label, skey, style = {} }) => (
    <div style={{ ...colHeaderSt, cursor: 'pointer', color: sortKey === skey ? '#fff' : 'rgba(255,255,255,0.38)', ...style }}
      onClick={() => handleSortClick(skey)}>
      {label}{sortKey === skey ? (sortDir === 'asc' ? ' ↑' : ' ↓') : ''}
    </div>
  );

  const sanitizeWrestler = (w) => {
    var clean = {};
    Object.keys(w).forEach(function(key) {
      var val = w[key];
      if (val === undefined || val === null) return;
      if (typeof val === 'function') return;
      // Skip large base64 images for Firebase — store separately if needed
      if (typeof val === 'string' && val.startsWith('data:') && val.length > 500000) return;
      if (typeof val === 'object' && !Array.isArray(val) && !(val instanceof Date)) {
        // Recursively sanitize nested objects
        clean[key] = sanitizeWrestler(val);
      } else {
        clean[key] = val;
      }
    });
    return clean;
  };

  const handleSave = async () => {
    if (!rosterName) return;
    const included = roster.filter(w => w.status === 'active' || w.isCustom);
    if (included.length === 0) return;
    setSaving(true);
    try {
      if (!initialName) {
        // New roster — save to Firebase
        await addDoc(collection(db, 'customRosters'), {
          userId: user.uid, name: rosterName,
          wrestlers: included.map(sanitizeWrestler), createdAt: new Date(), count: included.length,
        });
      }
      setSaving(false);
      onSaveAndConfirm(included, rosterName);
    } catch (e) {
      console.error('Save error:', e);
      setSaving(false);
      // Even if Firebase fails, still proceed to draft
      onSaveAndConfirm(included, rosterName);
    }
  };

  return (
    <PageWrapper brand={brand}>
      <style>{css}</style>
      {editTarget && <EditSuperstarsPopup
        user={user}
        wrestler={editTarget}
        originalWrestler={originalWrestlers.find(w => w.wrestler_id === editTarget.wrestler_id)}
        onClose={() => setEditTarget(null)}
        onSave={handleSaveEdit}
        onDelete={(id) => { setRoster(prev => prev.filter(w => w.wrestler_id !== id)); setEditTarget(null); }}
      />}
      {showCustomEditor && (
        <CustomWrestlerEditor
          wrestler={null}
          userId={user && user.uid}
          onClose={() => setShowCustomEditor(false)}
          onSaved={(w) => { handleAddSuperstar(w); setShowCustomEditor(false); }}
        />
      )}

      <div style={{ width: '100%', maxWidth: '1160px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <div style={{ ...titleSt, fontSize: '1.3rem' }}>ROSTER</div>

        <div style={{ ...panel, maxHeight: '82vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <div style={{ display: 'flex', flex: 1, overflow: 'hidden', padding: '16px 20px 12px', gap: '16px' }}>

            {/* LEFT — preview + name */}
            <div style={{ width: '240px', flexShrink: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {/* Roster name */}
              <div>
                <label style={labelSt}>CUSTOM ROSTER NAME</label>
                <input style={{ ...inputSt, width: '100%' }} placeholder="Nom du roster..."
                  value={rosterName} onChange={e => setRosterName(e.target.value)}
                  onFocus={e => e.target.style.borderColor = 'rgba(255,255,255,0.5)'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.15)'} />
              </div>

              {/* Preview panel */}
              <div style={{ height: '280px', borderRadius: '8px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.2)', position: 'relative', display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
                <img loading="lazy" src={background} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(3px)', zIndex: 0 }} />
                <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 1 }} />
                <div style={{ position: 'absolute', inset: 0, background: `radial-gradient(ellipse at bottom, ${brandColor}18 0%, transparent 70%)`, zIndex: 1 }} />

                <div style={{ position: 'relative', zIndex: 2, flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                  <img loading="lazy" src={getWrestlerRender(activeW) || placeholder} alt="superstar"
                    style={{ width: '100%', maxWidth: '220px', objectFit: 'contain', objectPosition: 'top', filter: 'drop-shadow(0 4px 16px rgba(0,0,0,0.8))' }} />
                </div>

                <div style={{ position: 'relative', zIndex: 2, padding: '8px 10px 12px', background: 'rgba(0,0,0,0.7)', borderTop: `1px solid ${brandColor}33`, textAlign: 'center' }}>
                  <div style={{ fontFamily: "'Anton', sans-serif", fontSize: '0.72rem', letterSpacing: '1.5px', color: '#fff', marginBottom: '6px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {activeW ? getWrestlerNameUpper(activeW, 'display') : 'SUPERSTAR'}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: '5px' }}>
                    {[CLASS_COLORS[activeW?.fight_class] || '#444', activeW ? (activeW.heel ? '#e74c3c' : '#2ecc71') : '#444', '#d4af37'].map((color, i) => (
                      <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px' }}>
                        <div style={{ width: '14px', height: '14px', borderRadius: '50%', background: color, boxShadow: `0 0 6px ${color}88` }} />
                        <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.38rem', color: 'rgba(255,255,255,0.3)' }}>{['CLASS', 'ROLE', 'XP'][i]}</div>
                      </div>
                    ))}
                  </div>
                  {activeW && (
                    <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.44rem', color: 'rgba(255,255,255,0.45)' }}>
                      {activeW.gender === 'F' ? '♀' : '♂'} · {activeW.fight_class}<br />
                      <span style={{ color: activeW.heel ? '#e74c3c' : '#2ecc71' }}>{activeW.heel ? 'HEEL' : 'FACE'}</span> · XP {activeW.starting_xp || 0}
                    </div>
                  )}
                </div>
              </div>

              {/* Stats panel */}
              <div style={{ background: 'rgba(8,8,8,0.7)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', padding: '10px 12px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {/* Status */}
                <div>
                  <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.52rem', letterSpacing: '1.5px', color: 'rgba(255,255,255,0.35)', marginBottom: '5px' }}>STATUS</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                    {[
                      { key: 'active', label: 'Active', color: '#2ecc71' },
                      { key: 'inactive', label: 'Inactive', color: '#888' },
                      { key: 'contract', label: 'Contract', color: '#3498db' },
                      { key: 'local', label: 'Local', color: '#f39c12' },
                    ].map(({ key, label, color }) => {
                      const count = roster.filter(w => w.status === key).length;
                      return count > 0 ? (
                        <div key={key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <span style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.5rem', color: 'rgba(255,255,255,0.4)' }}>{label}</span>
                          <span style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.52rem', color, fontWeight: 'bold' }}>{count}</span>
                        </div>
                      ) : null;
                    })}
                  </div>
                </div>
                {/* Divider */}
                <div style={{ height: '1px', background: 'rgba(255,255,255,0.07)' }} />
                {/* Class */}
                <div>
                  <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.52rem', letterSpacing: '1.5px', color: 'rgba(255,255,255,0.35)', marginBottom: '5px' }}>CLASS</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                    {[
                      { key: 'Specialist', color: '#9b59b6' },
                      { key: 'Fighter', color: '#3498db' },
                      { key: 'Bruiser', color: '#e74c3c' },
                      { key: 'Cruiser', color: '#2ecc71' },
                      { key: 'Giant', color: '#e67e22' },
                    ].map(({ key, color }) => {
                      const count = roster.filter(w => w.fight_class === key).length;
                      return count > 0 ? (
                        <div key={key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <span style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.5rem', color: 'rgba(255,255,255,0.4)' }}>{key}</span>
                          <span style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.52rem', color, fontWeight: 'bold' }}>{count}</span>
                        </div>
                      ) : null;
                    })}
                  </div>
                </div>
                {/* Divider */}
                <div style={{ height: '1px', background: 'rgba(255,255,255,0.07)' }} />
                {/* Role */}
                <div>
                  <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.52rem', letterSpacing: '1.5px', color: 'rgba(255,255,255,0.35)', marginBottom: '5px' }}>ROLE</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                    {[
                      { key: true, label: 'Heel', color: '#e74c3c' },
                      { key: false, label: 'Face', color: '#2ecc71' },
                    ].map(({ key, label, color }) => {
                      const count = roster.filter(w => !!w.heel === key).length;
                      return (
                        <div key={label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <span style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.5rem', color: 'rgba(255,255,255,0.4)' }}>{label}</span>
                          <span style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.52rem', color, fontWeight: 'bold' }}>{count}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT — table */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '10px', overflow: 'hidden' }}>
              {/* Search + sort + new superstar */}
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <input style={{ ...inputSt, flex: 2 }} placeholder="RECHERCHE"
                  value={search} onChange={e => setSearch(e.target.value)}
                  onFocus={e => e.target.style.borderColor = 'rgba(255,255,255,0.5)'}
                  onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.15)'} />
                <select style={{ ...inputSt, flex: 1, cursor: 'pointer' }}
                  value={`${sortKey}-${sortDir}`}
                  onChange={e => { const [k, d] = e.target.value.split('-'); setSortKey(k); setSortDir(d); }}>
                  <option value="name-asc">NOM A → Z</option>
                  <option value="name-desc">NOM Z → A</option>
                  <option value="status-asc">STATUS A → Z</option>
                  <option value="class-asc">CLASS A → Z</option>
                  <option value="role-asc">ROLE A → Z</option>
                  <option value="gender-asc">GENRE A → Z</option>
                  <option value="xp-desc">RING XP ↓</option>
                  <option value="xp-asc">RING XP ↑</option>
                  <option value="promo-desc">PROMO ↓</option>
                  <option value="promo-asc">PROMO ↑</option>
                  <option value="custom-asc">CUSTOM ONLY</option>
                </select>
                <button className="btn-wwe"
                  onClick={() => setShowCustomEditor(true)}
                  style={{ ...btnSt, padding: '7px 14px', fontSize: '0.55rem', whiteSpace: 'nowrap', borderColor: 'rgba(212,175,55,0.5)', color: '#d4af37', display: 'flex', alignItems: 'center', gap: '5px' }}>
                  ✦ NEW SUPERSTAR
                </button>
              </div>

              {/* Table */}
              <div style={{ flex: 1, overflow: 'hidden', border: '1px solid rgba(255,255,255,0.07)', borderRadius: '8px', display: 'flex', flexDirection: 'column' }}>
                {/* Header */}
                <div style={{ display: 'grid', gridTemplateColumns: '2fr 0.5fr 0.7fr 0.8fr 0.7fr 0.8fr 0.6fr 0.6fr', background: 'rgba(0,0,0,0.6)', flexShrink: 0 }}>
                  <SortTh label="SUPERSTAR" skey="name" />
                  <div style={colHeaderSt}>EDIT</div>

                  <SortTh label="STATUS" skey="status" />
                  <SortTh label="GENRE" skey="gender" />
                  <SortTh label="CLASS" skey="class" />
                  <SortTh label="ROLE" skey="role" />
                  <SortTh label="XP" skey="xp" />
                  <SortTh label="PROMO" skey="promo" />
                </div>

                {/* Rows */}
                <div style={{ flex: 1, overflowY: 'auto' }}>
                  {filtered.map((w, i) => {
                    const isInactive = w.status === 'inactive';
                    const isHov = hoveredIdx === i;
                    const isSel = selectedIdx === i;
                    return (
                      <div key={`${w.wrestler_id}-${i}`}
                        className={`row-hover${isSel ? ' sel-row' : ''}${isInactive ? ' row-inactive' : ''}`}
                        onMouseEnter={() => setHoveredIdx(i)}
                        onMouseLeave={() => setHoveredIdx(null)}
                        onClick={() => setSelectedIdx(i)}
                        style={{ display: 'grid', gridTemplateColumns: '2fr 0.5fr 0.7fr 0.8fr 0.7fr 0.8fr 0.6fr 0.6fr', background: i % 2 === 0 ? 'rgba(255,255,255,0.02)' : 'transparent', borderBottom: '1px solid rgba(255,255,255,0.04)' }}>

                        {/* Name */}
                        <div style={{ padding: '7px 8px', fontFamily: "'Monda', sans-serif", fontSize: '0.58rem', color: isHov || isSel ? '#fff' : 'rgba(255,255,255,0.72)', display: 'flex', alignItems: 'center', gap: '4px' }}>
                          {w.isCustom && <span style={{ fontSize: '0.4rem', color: '#d4af37', background: 'rgba(212,175,55,0.15)', border: '1px solid rgba(212,175,55,0.3)', borderRadius: '2px', padding: '1px 3px', letterSpacing: '0.5px', fontFamily: "'Monda', sans-serif" }}>CUSTOM</span>}
                          {getWrestlerName(w, 'display')}
                        </div>

                        {/* Edit */}
                        <div style={{ padding: '5px 6px', display: 'flex', alignItems: 'center' }}>
                          <button className="btn-edit"
                            onClick={e => { e.stopPropagation(); handleEdit(w); }}
                            style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.42rem', letterSpacing: '1px', background: 'transparent', border: '1px solid rgba(255,255,255,0.2)', color: 'rgba(255,255,255,0.4)', padding: '3px 6px', borderRadius: '3px', cursor: 'pointer', transition: 'background 0.15s, border-color 0.15s, color 0.15s' }}>
                            EDIT
                          </button>
                        </div>

                        {/* Status */}
                        <div style={{ padding: '7px 8px', fontFamily: "'Monda', sans-serif", fontSize: '0.46rem', color: STATUS_COLORS[w.status] || '#fff', textTransform: 'uppercase', display: 'flex', alignItems: 'center' }}>{w.status}</div>

                        {/* Gender */}
                        <div style={{ padding: '7px 8px', fontFamily: "'Monda', sans-serif", fontSize: '0.46rem', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', display: 'flex', alignItems: 'center' }}>{w.gender === 'F' ? 'female' : 'male'}</div>

                        {/* Class */}
                        <div style={{ padding: '7px 8px', fontFamily: "'Monda', sans-serif", fontSize: '0.46rem', color: CLASS_COLORS[w.fight_class] || 'rgba(255,255,255,0.5)', textTransform: 'uppercase', display: 'flex', alignItems: 'center' }}>{w.fight_class}</div>

                        {/* Role */}
                        <div style={{ padding: '7px 8px', fontFamily: "'Monda', sans-serif", fontSize: '0.46rem', color: w.heel ? '#e74c3c' : '#2ecc71', textTransform: 'uppercase', display: 'flex', alignItems: 'center' }}>{w.heel ? 'heel' : 'face'}</div>

                        {/* XP */}
                        <div style={{ padding: '7px 8px', fontFamily: "'Monda', sans-serif", fontSize: '0.46rem', color: 'rgba(255,255,255,0.55)', display: 'flex', alignItems: 'center' }}>{w.starting_xp || 0}</div>

                        {/* PROMO */}
                        <div style={{ padding: '7px 8px', fontFamily: "'Monda', sans-serif", fontSize: '0.46rem', color: 'rgba(155,89,182,0.7)', display: 'flex', alignItems: 'center' }}>🎤 {w.promo_skill || 1}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div style={{ padding: '12px 20px', borderTop: '1px solid rgba(255,255,255,0.06)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <button className="btn-wwe" style={{ ...btnSt, color: 'rgba(255,255,255,0.35)', borderColor: 'rgba(255,255,255,0.15)' }} onClick={onBack}>← BACK</button>
            <button className="btn-wwe"
              style={{ ...btnSt, borderColor: rosterName ? 'rgba(255,255,255,0.55)' : 'rgba(255,255,255,0.18)', color: rosterName ? '#fff' : 'rgba(255,255,255,0.25)', opacity: saving ? 0.6 : 1 }}
              onClick={handleSave} disabled={!rosterName || roster.length === 0 || saving}>
              {saving ? 'SAVING...' : 'SAVE & CONFIRM'}
            </button>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

// ── STEP 2b: LOAD ───────────────────────────────────────────────────
const StepLoadRoster = ({ brand, user, wrestlers, onBack, onConfirm }) => {
  const [rosters, setRosters] = useState([]);
  const [selectedRoster, setSelectedRoster] = useState(null);
  const [loading, setLoading] = useState(true);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [editTarget, setEditTarget] = useState(null);
  const brandLogo = BRAND_LOGOS[brand];

  useEffect(() => {
    const fetch = async () => {
      const q = query(collection(db, 'customRosters'), where('userId', '==', user.uid));
      const snap = await getDocs(q);
      setRosters(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    };
    fetch();
  }, [user]);

  const handleSaveEdit = async (updatedRoster, updatedName, rosterId) => {
    const { doc: firestoreDoc, updateDoc } = await import('firebase/firestore');
    const ref = firestoreDoc(db, 'customRosters', rosterId);
    await import('firebase/firestore').then(async ({ updateDoc, doc }) => {
      await updateDoc(doc(db, 'customRosters', rosterId), {
        name: updatedName,
        wrestlers: updatedRoster,
        count: updatedRoster.length,
      });
    });
    setRosters(prev => prev.map(r => r.id === rosterId ? { ...r, name: updatedName, wrestlers: updatedRoster, count: updatedRoster.length } : r));
    setEditTarget(null);
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, 'customRosters', id));
    setRosters(prev => prev.filter(r => r.id !== id));
    if (selectedRoster?.id === id) setSelectedRoster(null);
    setDeleteTarget(null);
  };

  const formatDate = (ts) => {
    if (!ts) return '-';
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  if (editTarget) return (
    <StepNewRoster
      brand={brand}
      wrestlers={wrestlers}
      user={user}
      initialRoster={editTarget.wrestlers}
      initialName={getWrestlerName(editTarget, 'display')}
      onBack={() => setEditTarget(null)}
      onSaveAndConfirm={(roster, name) => handleSaveEdit(roster, name, editTarget.id)}
    />
  );

  return (
    <PageWrapper brand={brand}>
      <style>{css}</style>
      <div style={{ width: '100%', maxWidth: '700px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          {brandLogo && <img loading="lazy" src={brandLogo} alt={brand} style={{ height: '36px', objectFit: 'contain', filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.9))' }} />}
          <div style={{ ...titleSt, fontSize: '1.3rem' }}>LOAD ROSTER</div>
        </div>
        <div style={{ ...panel, maxHeight: '560px', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <div style={{ flex: 1, overflowY: 'auto', padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {loading && <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.6rem', color: 'rgba(255,255,255,0.3)', textAlign: 'center', padding: '40px' }}>Chargement...</div>}
            {!loading && rosters.length === 0 && (
              <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.6rem', color: 'rgba(255,255,255,0.3)', textAlign: 'center', padding: '40px' }}>
                Aucun roster sauvegardé.<br /><span style={{ fontSize: '0.5rem' }}>Créez-en un avec NEW ROSTER.</span>
              </div>
            )}
            {rosters.map(r => {
              const isSel = selectedRoster?.id === r.id;
              return (
                <div key={r.id} className={`roster-card${isSel ? ' selected-card' : ''}`}
                  onClick={() => setSelectedRoster(r)}
                  style={{ ...panel, padding: '14px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', outline: '1.5px solid transparent', transition: 'background 0.15s, border-color 0.15s, color 0.15s' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flex: 1 }}>
                    {isSel && <span style={{ color: '#2ecc71', fontSize: '0.85rem' }}>✓</span>}
                    <div>
                      <div style={{ fontFamily: "'Anton', sans-serif", fontSize: '0.85rem', letterSpacing: '2px', color: '#fff', marginBottom: '3px' }}>{r.name}</div>
                      <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.48rem', color: 'rgba(255,255,255,0.35)', letterSpacing: '0.5px' }}>
                        {r.count} lutteurs · Créé le {formatDate(r.createdAt)}
                      </div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button className="btn-wwe"
                      onClick={e => { e.stopPropagation(); setEditTarget(r); }}
                      style={{ ...btnSt, fontSize: '0.48rem', padding: '4px 10px', borderColor: 'rgba(52,152,219,0.4)', color: 'rgba(52,152,219,0.7)' }}>EDIT</button>
                    <button className="btn-wwe"
                      onClick={e => { e.stopPropagation(); setDeleteTarget(r); }}
                      style={{ ...btnSt, fontSize: '0.48rem', padding: '4px 10px', borderColor: 'rgba(231,76,60,0.4)', color: 'rgba(231,76,60,0.7)' }}>✕</button>
                  </div>
                </div>
              );
            })}
          </div>
          <div style={{ padding: '12px 20px', borderTop: '1px solid rgba(255,255,255,0.06)', display: 'flex', justifyContent: 'space-between' }}>
            <button className="btn-wwe" style={{ ...btnSt, color: 'rgba(255,255,255,0.35)', borderColor: 'rgba(255,255,255,0.15)' }} onClick={onBack}>← BACK</button>
            <button className="btn-wwe"
              style={{ ...btnSt, borderColor: selectedRoster ? 'rgba(255,255,255,0.55)' : 'rgba(255,255,255,0.18)', color: selectedRoster ? '#fff' : 'rgba(255,255,255,0.25)' }}
              onClick={() => selectedRoster && onConfirm(selectedRoster.wrestlers)} disabled={!selectedRoster}>
              CONFIRM
            </button>
          </div>
        </div>
      </div>
      {deleteTarget && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(4px)' }}>
          <div style={{ ...panel, maxWidth: '360px', width: '100%', padding: '28px', textAlign: 'center' }}>
            <div style={{ fontFamily: "'Anton', sans-serif", fontSize: '0.95rem', color: '#e74c3c', letterSpacing: '2px', marginBottom: '10px' }}>DELETE ROSTER?</div>
            <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.6rem', color: 'rgba(255,255,255,0.4)', marginBottom: '20px' }}>"{deleteTarget.name}" sera supprimé définitivement.</div>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button className="btn-wwe" style={btnSt} onClick={() => setDeleteTarget(null)}>CANCEL</button>
              <button className="btn-wwe" style={{ ...btnSt, borderColor: 'rgba(231,76,60,0.6)', color: '#e74c3c' }} onClick={() => handleDelete(deleteTarget.id)}>DELETE</button>
            </div>
          </div>
        </div>
      )}
    </PageWrapper>
  );
};

// ── MAIN ────────────────────────────────────────────────────────────
export default function CustomRosterManager({ user, wrestlers, brand, onClose, onConfirm }) {
  const [step, setStep] = useState('choice');
  if (step === 'choice') return <StepChoice brand={brand} onNew={() => setStep('new')} onLoad={() => setStep('load')} onClose={onClose} />;
  if (step === 'new') return <StepNewRoster brand={brand} wrestlers={wrestlers} user={user} onBack={() => setStep('choice')} onSaveAndConfirm={onConfirm} />;
  if (step === 'load') return <StepLoadRoster brand={brand} user={user} wrestlers={wrestlers} onBack={() => setStep('choice')} onConfirm={onConfirm} />;
  return null;
}
